var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center flex-column p-2",staticStyle:{"min-height":"200px"}},[_c('b-spinner',{staticStyle:{"width":"4rem","height":"4rem"},attrs:{"variant":"primary","label":"Spinning"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }